/* Copyright(c) 2019 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/

/*
@author:Sanobar Golandaj
@Creation Date:10-10-2019
@Description:UI for (Dashboard) campaign specification
*/

import React,{ Component } from 'react'
import Navigation from '../layouts/navPage';
import Footer from '../layouts/footer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom'; 
import CampaignSpecificationAdvertiserDashboardDetails from "./campaignSpecificationAdvertiserDashboardDetails";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";//snehal-task-3766-specification VAPT api call
import { Badge } from 'antd';//Kiran Dhainje 5958- import badge for showing count of notes on notes icon
import '../publisher/publisherInternalReviewLead.css';

// const queryString = require('query-string');
// var greeting=""; //kiran-4747-removing console warning-no used
class CampaignSpecificationAdvertiserDashboard extends Component{

    constructor() {
       
        super();
        this.state = {
              campID: '',
              parentCampID:'',
              reallocationID:'',
              advertiserID:'',
              campaignName:'',
              showNotesModal: false,//Kiran Dhainje 5958-added state for showNotesModal and below states for internal campaign notes
              campaignNotes: "",//Kiran Dhainje 5958-added state for campaignNotes which will be used to store the notes entered in textarea before sending to backend
              campaignNotesHistory: [],//Kiran Dhainje 5958-added state for campaignNotesHistory which will be used to store the notes history fetched from backend for a campaign
              editingNoteId: null,//Kiran Dhainje 5958-added state for editingNoteId which will be used to store the note id of note which is being edited currently
              editingNoteText: "",//Kiran Dhainje 5958-added state for editingNoteText which will be used to store the edited note text before saving it to backend
        }
        this.handleBackButtonToDashboard=  this.handleBackButtonToDashboard.bind(this);
        this.handleFileDownload = this.handleFileDownload.bind(this);
        this.handleFileShowDownload = this.handleFileShowDownload.bind(this);
        this.handlePDFFileShowDownload = this.handlePDFFileShowDownload.bind(this);
        this.notesPanelRef = React.createRef();//Kiran Dhainje 5958-added this ref for internal notes panel to handle auto scroll to notes after adding new note
        this.notesBodyRef = React.createRef();//Kiran Dhainje 5958-added this ref for internal notes body to handle auto scroll to notes after adding new note
    }

    componentDidMount() {  
      if(!this.props.auth.isAuthenticated) {
        this.props.history.push('/userLogin');
      }
      else{
        //snehal-task-3766-specification VAPT api call 
       //Kiran Dhainje 5958 - added code to get campID, parentCampID and reallocationID from location state or session storage and set it in state and then fetch notes for that campaign immediately after setting campID in state 
        let campID;
        if(this.props.location.state!==undefined){
          var parsed = this.props.location.state;
          campID=parsed.campID;
          var parentCampID=parsed.parentCampID;
          var reallocationID=parsed.reallocationID;
        }
        else if (sessionStorage.getItem("campID") !== undefined) {
           campID = sessionStorage.getItem("campID");
           parentCampID = sessionStorage.getItem("parentCampID");
           reallocationID = sessionStorage.getItem("reallocationID");
        } else {
          if (sessionStorage.getItem("parentCampID") === undefined) {
            sessionStorage.clear();
          }
        }
      const { user} = this.props.auth;
      var advertiserID=user.id;
  this.setState({ campID: campID, parentCampID: parentCampID, reallocationID: reallocationID, advertiserID: advertiserID }, () => {
        if (campID) {
          this.getCampaignNotes();
        }
      });
      fetch("campaign/CampaignDetails?campID=" + campID)
      .then(res => res.json())
      .then(campaignDetails =>{
        this.setState({campaignName:campaignDetails[0].campaignName});
        }).catch(function (err) {
        console.log(err)
      });
//Kiran Dhainje 5958 - added event listener for global click to handle closing of notes modal when user clicks outside of it
      document.addEventListener("mousedown", this.handleGlobalClick, true);
    }
    }

     componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleGlobalClick, true);
    }

    componentDidUpdate(prevProps, prevState) {
      const campIDChanged = prevState.campID !== this.state.campID;

      if (campIDChanged) {
        this.setState(
          {
            campaignNotesHistory: [],
            campaignNotes: "",
          },
          () => {
            if (this.state.campID) {
              this.getCampaignNotes();
            }
          },
        );
      }

      const notesCountChanged =
        prevState.campaignNotesHistory.length !==
          this.state.campaignNotesHistory.length;
      const notesPanelJustOpened =
        !prevState.showNotesModal && this.state.showNotesModal;

      if (
        this.state.showNotesModal &&
        (notesCountChanged || notesPanelJustOpened)
      ) {
        this.scrollNotesToBottom();
      }
    }
    handleBackButtonToDashboard(e){
      e.preventDefault();//kiran-4747-removing console warning-added e.preventDefault();
          this.props.history.push("/advertiserDashboard",{advertiserID:this.state.advertiserID})//snehal-task-3768-vAPT URL changes
      }
    
    handleFileDownload(e) {
        var campID=this.state.campID;
        // var parentCampID=this.state.parentCampID;//kiran-4747-removing console warning-no used
         /**
       * @author Narendra Phadke
       * @param  Description handle the Campaign related Files
       * @return Description return All The File Download in Zip
       */
          console.warn("campID===>"+campID);
        
        var formData=new FormData();
        formData.append("campID",campID);
        // const { user} = this.props.auth;
        // var userID=user.id; //kiran-4747-removing console warning-no used
      //This api is used for dynamic pdf genration
      //snehal-task-3766-specification VAPT api call
       fetch("agency/downloadDynamicPDFCampaignDetailsforAgency?campID=" + campID + "&campName="+this.state.campaignName ).then(r => r.blob())
          .then(downloadFiles =>
            this.setState({ downloadFiles: downloadFiles })
            )
            .then(this.handlePDFFileShowDownload);

          //snehal-task-3766-specification VAPT api call
          fetch("agency/downloadCampaignDetailsforAgency?campID=" + campID + "&campName="+encodeURIComponent(this.state.campaignName) ).then(r => r.blob())  //Rutuja task 5636 passing campaign name by doing ecodeURI
          .then(downloadFiles =>
            this.setState({ downloadFiles: downloadFiles })
            )
            .then(this.handleFileShowDownload);
        }/** End of handle File Download */

        handleFileShowDownload(blob){
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            let zipFileDownloadName=this.state.campID +'-'+this.state.campaignName+".zip"; //Rutuja 5542  changed parentcamp id to camp id
          
            var newBlob = new Blob([this.state.downloadFiles], {type: "application/zip"})
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
            } 
           
            // For other browsers: 
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download=zipFileDownloadName;
            link.click();
          
          // ));
        }

        handlePDFFileShowDownload(blob){
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            let zipFileDownloadName=this.state.campID+'-'+this.state.campaignName+"-CampaignSpecification.pdf"; //Rutuja 5542    changed parentcamp id to camp id
             var newBlob = new Blob([this.state.downloadFiles], {type: "application/pdf"})
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
            } 
           
            // For other browsers: 
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download=zipFileDownloadName;
            link.click();
          
          // ));
  
          }
      
             //Kiran Dhainje 5958 - added this function to handle global click for closing notes modal when user clicks outside of it  
    handleGlobalClick = (event) => {
      if (!this.state.showNotesModal) {
        return;
      }
      if (
        this.notesPanelRef.current &&
        this.notesPanelRef.current.contains(event.target)
      ) {
        return;
      }
      this.closeNotesModal();
    };

    scrollNotesToBottom = () => {
      if (this.notesBodyRef.current) {
        this.notesBodyRef.current.scrollTop = this.notesBodyRef.current.scrollHeight;
      }
    };

    openNotesModal = () => {
      if (!this.state.campID || String(this.state.campID).trim() === "") {
        alert("Campaign ID is not available.");
        return;
      }
      const isOpening = !this.state.showNotesModal;
      this.setState(
        (prevState) => ({ showNotesModal: !prevState.showNotesModal }),
        () => {
          if (isOpening) {
            this.getCampaignNotes();
          }
        }
      );
    };

    closeNotesModal = () => {
      this.setState({ showNotesModal: false });
    };

    getCampaignNotes = async () => {
      const campID = String(this.state.campID).trim();
      if (!campID) return;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "fetch", campaign_id: campID }),
        });
        const data = await response.json();
        console.log("Notes response:", data);
        if (data.success) {
          this.setState({ campaignNotesHistory: data.result || [] });
        }
      } catch (err) {
        console.error("Error fetching notes:", err);
      }
    };

    handleNotesChange = (event) => {
      this.setState({ campaignNotes: event.target.value });
    };

    handleNotesKeyDown = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.handleSendNotes();
      }
    };

    handleSendNotes = async () => {
      const { campaignNotes, campID } = this.state;
      if (!campaignNotes.trim()) return;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "add", campaign_id: campID, sender_id: this.props.auth.user.userID, message: campaignNotes }),
        });
        const result = await response.json();
        if (result.success) {
          this.setState({ campaignNotes: "" });
          this.getCampaignNotes();
        }
      } catch (err) {
        console.error("Error sending notes:", err);
      }
    };

    handleEditNote = (noteId, noteMessage = "") => {
      this.setState({ editingNoteId: noteId, editingNoteText: noteMessage });
    };

    handleEditNoteSave = async (noteId) => {
      const { editingNoteText, campID } = this.state;
      if (!editingNoteText.trim()) return;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "edit", note_id: noteId, campaign_id: campID, message: editingNoteText, sender_id: this.props.auth.user.userID }),
        });
        const result = await response.json();
        if (result.success) {
          this.setState({ editingNoteId: null, editingNoteText: "" });
          this.getCampaignNotes();
        }
      } catch (err) {
        console.error("Error editing note:", err);
      }
    };

    handleDeleteNote = async (noteId) => {
      const { campID } = this.state;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "delete", note_id: noteId, campaign_id: campID, sender_id: this.props.auth.user.userID }),
        });
        const result = await response.json();
        if (result.success) {
          this.getCampaignNotes();
        }
      } catch (err) {
        console.error("Error deleting note:", err);
      }
    };

    resolveNoteUserMeta = (note) => {
      const name = note.sender_full_name || note.sender_name || "Unknown";
      const initials = name.split(' ').map((n) => n[0]).join('').toUpperCase() || "U";
      return { name, initials };
    };

    formatTimestamp = (value) => {
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return "Invalid Date";
      const diff = Date.now() - date.getTime();
      if (diff < 60000) return "Just now";
      if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
      const today = new Date();
      if (date.toDateString() === today.toDateString()) return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
      return date.toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
      });
    };

    getTimestampLabel = (note) => {
      const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
      if (!rawTimestamp) return "";
      const formatted = this.formatTimestamp(rawTimestamp);
      if (note.Edited_attempt > 0) return `Edited ${formatted}`;
      return formatted;
    };

    getTimestampTitle = (note) => {
      const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
      if (!rawTimestamp) return "";
      const date = new Date(rawTimestamp);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    };
           

    render()
    {
      //snehal-task-3766-specification VAPT api call
      if(this.props.location.state!==undefined ){
      this.state.campID=this.props.location.state.campID;
      this.state.parentCampID=this.props.location.state.parentCampID
      this.state.reallocationID=this.props.location.state.reallocationID;

      }
      else if (sessionStorage.getItem("campID") !== undefined) {
        this.state.campID = sessionStorage.getItem("campID");
        this.state.parentCampID = sessionStorage.getItem("parentCampID");
        this.state.reallocationID = sessionStorage.getItem("reallocationID");
      }
        return(
            <div>
           
           <Navigation/>
           {/* Nilesh-4839 Add display, flexDirection,flex, backgroundColor, paddingTop, position, top and zIndex in below div */}
           <div style={{paddingTop:'110px', display: "flex", flexDirection: "column"}}>
          
             <div class="container-fluid fixed-top" style={{
						flex: "0 0 auto",
						backgroundColor:"rgb(245 245 245)",
						paddingTop: "10px",
						position: "sticky",
						top: "79px",
						zIndex: "999"
					}}>
             <div class="row" style={{paddingBottom:'20px'}}>
            {/* Akash-Bug-4215 */}
            {/* kiran-4747-removing console warning-added "#/" */}
             <div class="col-lg-3 col-md-2 col-sm-3"><a href='#/'> <FaArrowAltCircleLeft size={32} style={{float:'left',color:'#056eb8'}} title="Back to Dashboard" onClick={this.handleBackButtonToDashboard} /></a></div>
            
              <div class="col-lg-6 col-md-8 col-sm-6" align="center">
                {/* snehal-task-3561-Reff(3428)----spec and cust mapping format issue  */}
                <label 
                       style={{                       
                        color: "#193D8F",
                        fontSize: "28px",                       
                        fontWeight:'500',
                        fontFamily:'roboto'}}>
                          Campaign ID:{this.state.campID}</label></div> {/*sunita-task-3727- added campaign id as per requirement */}
             
            {/*Kiran Dhainje 5958 Added below code for internal campaign notes */}
             {/*Kiran Dhainje 6001 Changed Below Code for Alignment */}
             <div className="col-lg-3 col-md-2 col-sm-3 d-flex justify-content-end align-items-center gap-2">

                  <Badge
                    count={
                      this.state.campaignNotesHistory.length > 10
                        ? "10+"
                        : this.state.campaignNotesHistory.length
                    }
                    overflowCount={10}
                    offset={[-3, -10]}
                  >
                    <img
                      src="notes.png"
                      alt="Notes"
                      title="View Internal Campaign Notes"
                      style={{ width: '30px', height: '32px', cursor: 'pointer',marginBottom:'23px' }}
                      onClick={this.openNotesModal}
                    />
                  </Badge>

                  <button
                    type="button"
                    className="btn add-button"
                    id="cmd"
                    onClick={this.handleFileDownload}
                  >
                    Download
                  </button>

                </div>
                </div>
           </div>
          {/* <div>  */}
              <CampaignSpecificationAdvertiserDashboardDetails  greeting={this.state.campID}/> 
          {/* </div> */}
                
                 

               <div class="container-fluid" style={{paddingBottom:'70px'}}>
                 <div class="row">
                   {/* <div class="col-lg-4"></div>
                   <div class="col-lg-3"><label></label></div> */}
                   <div class="col-lg-5" style={{paddingTop:'20px'}}><button type="button"class="btn add-button" id="cmd" style={{float:'left'}}
                onClick={this.handleFileDownload}>Download</button></div> 
                 </div>
               </div>
           </div>
            {/*Kiran Dhainje 5958 Added below code for internal campaign notes */}
           {this.state.showNotesModal && (
             <div ref={this.notesPanelRef} className="internal-notes-wrapper">
               <div className="internal-notes-panel">
                 <button
                   type="button"
                   className="internal-notes-close"
                   onClick={this.closeNotesModal}
                   aria-label="Close internal campaign notes"
                 >
                   <span aria-hidden="true">&times;</span>
                 </button>
                 <div className="internal-notes-title">
                   <div className="internal-notes-heading">
                     Internal Campaign Notes
                   </div>
                   <div className="internal-notes-subtitle">
                     Campaign ID : <span>{this.state.campID || "--"}</span>
                   </div>
                 </div>
                 <div className="internal-notes-body" ref={this.notesBodyRef}>
                   {this.state.campaignNotesHistory.length > 0 ? (
                     this.state.campaignNotesHistory
                       .slice()
                       .reverse()
                       .map((note) => {
                         const { name, initials } = this.resolveNoteUserMeta(note);
                         const timestampLabel = this.getTimestampLabel(note);
                         const timestampTitle = this.getTimestampTitle(note);
                         const isJustNow = timestampLabel === "Just now";
                         const isEdited = note.Edited_attempt > 0;
                         return (
                           <div className="internal-note-item" key={note.note_id || note.id || note.created_at}>
                             <div className="internal-note-avatar">{initials}</div>
                             <div className="internal-note-content">
                               <div className="internal-note-header">
                                 <div className="internal-note-meta">
                                   <span className="internal-note-user">{name}</span>
                                   <span className={`internal-note-time ${isJustNow ? "internal-note-time-new" : ""} ${isEdited ? "internal-note-time-edited" : ""}`} title={timestampTitle}>
                                     {timestampLabel}
                                   </span>
                                 </div>
                               </div>
                               <div className="internal-note-message">
                                 {note.message}
                               </div>
                             </div>
                           </div>
                         );
                       })
                   ) : (
                     <div className="internal-notes-empty">
                       <p>No notes yet.</p>
                       <p>Add an internal update for this campaign.</p>
                     </div>
                   )}
                 </div>
               </div>
             </div>
           )}
           <Footer/>
            </div>





               
           
        )
    }
};

/**
       * @author Narendra Phadke
       * @param  Description handle the login authentication
       * @return Description return All details of authentication
       */
      CampaignSpecificationAdvertiserDashboard.propTypes = {
        logoutUser: PropTypes.func.isRequired,
        auth: PropTypes.object.isRequired
    }
    
    const mapStateToProps = (state) => ({
        auth: state.auth
    })
export default  connect(mapStateToProps, { logoutUser })(withRouter(CampaignSpecificationAdvertiserDashboard)); 
